(() => {
  const script = document.currentScript;
  const endpoint = script?.dataset.endpoint || "";
  const locale = (script?.dataset.locale || document.documentElement.lang || "es").toLowerCase().split("-")[0];
  const copy = {
    es: {
      launch: "Chat Green Tours",
      close: "Cerrar",
      label: "Chat Green Tours",
      placeholder: "¿En qué podemos ayudarte?",
      send: "Enviar",
      note: "Las respuestas son generadas por el asistente de Green Tours.",
      unavailable: "En este momento no podemos responder. Por favor intenta de nuevo en unos minutos.",
    },
    en: {
      launch: "Chat Green Tours",
      close: "Close",
      label: "Green Tours chat",
      placeholder: "How can we help you?",
      send: "Send",
      note: "Replies are generated by the Green Tours assistant.",
      unavailable: "We cannot respond right now. Please try again in a few minutes.",
    },
  }[locale] || {};
  if (!endpoint || document.querySelector("[data-greentours-chat-root]")) return;

  const sessionKey = "greentours-web-session";
  let sessionId = localStorage.getItem(sessionKey);
  if (!/^web_[A-Za-z0-9_-]{16,80}$/.test(sessionId || "")) {
    sessionId = `web_${crypto.randomUUID().replaceAll("-", "")}`;
    localStorage.setItem(sessionKey, sessionId);
  }
  const historyKey = `greentours-web-history:${sessionId}`;
  const maxHistory = 40;
  let history = [];
  try {
    const stored = JSON.parse(localStorage.getItem(historyKey) || "[]");
    if (Array.isArray(stored)) {
      history = stored.filter((item) => item && (item.role === "user" || item.role === "assistant") && typeof item.text === "string").slice(-maxHistory);
    }
  } catch {
    history = [];
  }

  const root = document.createElement("div");
  root.dataset.greentoursChatRoot = "";
  root.innerHTML = `
    <button type="button" class="gt-chat-launch" aria-expanded="false" aria-controls="gt-chat-panel">${copy.launch}</button>
    <section id="gt-chat-panel" class="gt-chat-panel" hidden aria-label="${copy.label}">
      <header class="gt-chat-header"><strong>Green Tours CR</strong><button type="button" class="gt-chat-close" aria-label="${copy.close}">×</button></header>
      <div class="gt-chat-messages" aria-live="polite"></div>
      <form class="gt-chat-form"><textarea maxlength="2000" required rows="2" placeholder="${copy.placeholder}"></textarea><button type="submit">${copy.send}</button></form>
      <small class="gt-chat-note">${copy.note}</small>
    </section>`;
  document.body.appendChild(root);

  const launch = root.querySelector(".gt-chat-launch");
  const panel = root.querySelector(".gt-chat-panel");
  const close = root.querySelector(".gt-chat-close");
  const messages = root.querySelector(".gt-chat-messages");
  const form = root.querySelector(".gt-chat-form");
  const input = form.querySelector("textarea");

  const saveHistory = () => {
    try {
      localStorage.setItem(historyKey, JSON.stringify(history.slice(-maxHistory)));
    } catch {
      // The chat remains usable when browser storage is unavailable.
    }
  };
  const appendAssistantText = (container, text) => {
    const urlPattern = /https?:\/\/[^\s<>"'`]+/g;
    let cursor = 0;
    for (const match of text.matchAll(urlPattern)) {
      const rawUrl = match[0];
      const start = match.index ?? cursor;
      if (start > cursor) container.appendChild(document.createTextNode(text.slice(cursor, start)));
      const url = rawUrl.replace(/[.,!?;:)\]]+$/g, "");
      const link = document.createElement("a");
      link.className = "gt-chat-link";
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.textContent = url;
      container.appendChild(link);
      if (url.length < rawUrl.length) container.appendChild(document.createTextNode(rawUrl.slice(url.length)));
      cursor = start + rawUrl.length;
    }
    if (cursor < text.length) container.appendChild(document.createTextNode(text.slice(cursor)));
  };
  const addMessage = (text, role, persist = true) => {
    const item = document.createElement("div");
    item.className = `gt-chat-message gt-chat-${role}`;
    if (role === "assistant") appendAssistantText(item, text);
    else item.textContent = text;
    messages.appendChild(item);
    messages.scrollTop = messages.scrollHeight;
    if (persist) {
      history.push({ text, role });
      history = history.slice(-maxHistory);
      saveHistory();
    }
  };
  history.forEach((item) => addMessage(item.text, item.role, false));
  const setOpen = (open) => {
    panel.hidden = !open;
    launch.setAttribute("aria-expanded", String(open));
    if (open) input.focus();
  };
  launch.addEventListener("click", () => setOpen(panel.hidden));
  close.addEventListener("click", () => setOpen(false));
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const message = input.value.trim();
    if (!message) return;
    input.value = "";
    addMessage(message, "user");
    const submit = form.querySelector("button");
    submit.disabled = true;
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionId, message }),
      });
      const data = await response.json();
      if (!response.ok || !data.reply) throw new Error("unavailable");
      addMessage(data.reply, "assistant");
    } catch {
      addMessage(copy.unavailable, "assistant");
    } finally {
      submit.disabled = false;
    }
  });
})();
